import PropTypes from 'prop-types';
import { Checkbox, Skeleton, Alert } from 'antd';
import { observer } from 'mobx-react';
import { CustomIcon } from '$src/components/CustomIcon';
import { contactType } from '$src/types';
import { getAlertTypes, alertMethods } from './constants';

import './index.less';

function AlertsPreferencesTable({ updatePreferences, contacts, alertPreferences, loading, updating }) {
  const alertTypes = getAlertTypes();

  const isChecked = (id, contact, method) => {
    const key = `${id}${method}`;
    if (Object.prototype.hasOwnProperty.call(alertPreferences, key) && alertPreferences[key].includes(`CONTACT${contact.seqNum}`)) return true;
    return false;
  };

  const methodsToText = (methods) => methods.map((method) => alertMethods.find((e) => e.id === method).description);

  const getKey = (id, method, contactId) => `${id}${method}${contactId}`;

  const buildCheckBoxes = ({ id, contact, methods, disabled }) =>
    methods.map((method) => (
      <td className="alert-preferences__checkbox" key={getKey(id, method, contact.seqNum)}>
        <Checkbox
          checked={disabled || isChecked(id, contact, method)}
          data-testid={getKey(id, method, `CONTACT${contact.seqNum}`)}
          disabled={disabled || updating}
          onChange={(e) => updatePreferences(`${id}${method}`, `CONTACT${contact.seqNum}`, e.target.checked)}
        />
      </td>
    ));

  const buildAlertPreference = ({ id, icon, title, description, methods, disabled }) => (
    <div className="alert-preferences__box" key={id} data-testid="alert-preferences-table">
      <CustomIcon type="regular" name={icon} />
      <table>
        <thead>
          <tr>
            <th className="alert-preferences__title">
              <div className="alert-preferences__title-container">
                <span className="alert-preferences__title-text">{title}</span>
                <span className="alert-preferences__title-description">{description}</span>
              </div>
            </th>
            {methodsToText(methods).map((m) => (
              <th className="alert-preferences__method" key={m}>
                {m}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {contacts.map((contact) => (
            <tr key={id + contact.seqNum} className="alert-preferences__contact-row">
              <td>
                <span className="alert-preferences__contact-name">
                  {contact.firstName} {contact.lastName}
                </span>
                <span className="alert-preferences__contact-description"> (Emergency Contact #{contact.seqNum})</span>
              </td>
              {buildCheckBoxes({ id, contact, methods, disabled })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <Skeleton active loading={loading}>
      {contacts?.length && alertPreferences ? (
        <>
          {alertTypes.map((alertType) =>
            buildAlertPreference({
              id: alertType.id,
              icon: alertType.icon,
              title: alertType.description,
              description: alertType.tooltipDescription,
              methods: alertType.methods,
              disabled: alertType.disabled,
            }),
          )}
        </>
      ) : (
        <Alert message="No Emergency Contacts" type="error" />
      )}
    </Skeleton>
  );
}

export default observer(AlertsPreferencesTable);

AlertsPreferencesTable.propTypes = {
  contacts: PropTypes.arrayOf(contactType),
  updatePreferences: PropTypes.func,
  alertPreferences: PropTypes.object,
  locationId: PropTypes.string,
  loading: PropTypes.bool,
  updating: PropTypes.bool,
};
